/*
 * 甲方项目模块接口
 */

import { post, get, put, del } from 'api/http'

export default {
    // 获取甲方项目列表
    getProjectList(data) {
        return get('/app/party_a/contract/list', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/partyA/partyAHome.js